import http from 'plugins/axios';
export default {

    addCoinRemindConfig(data){
        return http.post({
            url: '/admin/coin/remind/add',
            data,
            dataType: 'form'
        })
    },


    removeCoinRemindConfig(data){
        return http.post({
            url: '/admin/coin/remind/remove',
            data,
            dataType: 'form'
        })
    },


    alterCoinRemindConfig(data){
        return http.post({
            url: '/admin/coin/remind/alter',
            data,
            dataType: 'form'
        })
    },

    getCoinRechargeRemindConfigList(data){
        return http.get({
            url: '/admin/coin/remind/get/recharge/list',
            data
        })
    },

    getCoinExtractRemindConfigList(data){
        return http.get({
            url: '/admin/coin/remind/get/extract/list',
            data
        })
    }
}
